module.exports = __webpack_public_path__ + "static/media/1.a6bded96.jpeg";